import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from '~/config/routers'; 

Vue.use(VueRouter);

// 子路由默认使用父路由的module属性
routers.routes.forEach( item => {
    if (item.meta && item.meta.module) {
        if (_.size(item.children)) {
            item.children.forEach( item2 => {
                // let pred = item.meta.module && item2.meta &&  typeof item2.meta.module === 'undefined';
                // if (pred) item2.meta.module = item.meta.module;
                if (item2.meta && !item2.meta.module) {
                    item2.meta = _.defaults({}, item2.meta, { module: item.meta.module });
                } else {
                    // console.log(item.path, item2.path);
                }
            });
        }
    }
});
let router = new VueRouter(routers);
export default router;




// WEBPACK FOOTER //
// ./src/common/router.js